import React, { useReducer } from "react";
import profileApi from "api/profile";
import { appContextStore } from "context/createContext";
import LookupsState from "context/lookupsContext";
import {
  SET_USER,
  IS_AUTH_USER,
  REST_USER,
  GET_USER_DETAILS,
  GET_USER_DOMAINS,
  GET_USER_SUB_DOMAINS,
  SET_USER_DETAILS,
  SET_USER_DOMAINS,
  SET_USER_SUB_DOMAINS,
} from "context/types";

import AppReducer, { initialState } from "./appReducer";

const AppState = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  const setUser = (user = {}) => dispatch({ type: SET_USER, payload: user });
  const setAuth = (isAuth = false) => dispatch({ type: IS_AUTH_USER, isAuth });
  const resetUser = () => dispatch({ type: REST_USER });

  const getUserDetails = async (userId, cb = () => {}) => {
    try {
      if (Object.keys(state.userDetails).length > 0) {
        return;
      }
      const userData = await profileApi.getUserProfileByIdApi(userId);
      dispatch({ type: GET_USER_DETAILS, payload: userData });
      cb(true);
    } catch (e) {
      cb(false);
      console.error(e);
      dispatch({ type: GET_USER_DETAILS, payload: {} });
    }
  };

  const getUserDomains = async (userId, cb = () => {}) => {
    try {
      if (state?.userDomains?.length > 0) {
        return;
      }
      const domains = await profileApi.getUserDomainsByIdApi(userId);
      dispatch({ type: GET_USER_DOMAINS, payload: domains });
      cb(true);
    } catch (e) {
      console.error(e);
      dispatch({ type: GET_USER_DOMAINS, payload: [] });
      cb(false);
    }
  };

  const getUserSubDomains = async (userId, cb = () => {}) => {
    try {
      if (state?.userDomains?.length > 0) {
        return;
      }
      const subDomains = await profileApi.getUserSubDomainsByIdApi(userId);
      dispatch({ type: GET_USER_SUB_DOMAINS, payload: subDomains });
      cb(true);
    } catch (e) {
      console.error(e);
      dispatch({ type: GET_USER_SUB_DOMAINS, payload: [] });
      cb(false);
    }
  };

  const setUserDetails = (userDetails = {}) => {
    dispatch({ type: SET_USER_DETAILS, payload: userDetails });
  };

  const setUserDomains = (domains = []) => {
    dispatch({ type: SET_USER_DOMAINS, payload: domains });
  };

  const setUserSubDomains = (subDomains = []) => {
    dispatch({ type: SET_USER_SUB_DOMAINS, payload: subDomains });
  };

  return (
    <appContextStore.Provider
      value={{
        ...state,
        setUser,
        setAuth,
        resetUser,
        getUserDetails,
        getUserDomains,
        getUserSubDomains,
        setUserDetails,
        setUserDomains,
        setUserSubDomains,
      }}
    >
      {/* Our lookups state for the App */}
      <LookupsState>{children}</LookupsState>
    </appContextStore.Provider>
  );
};

export default AppState;
